import type {StateProvider, Transition} from '@uirouter/angularjs';
import type {KpUserAccountPageService} from './kp-user-account-page/kp-user-account-page.service';
import type UserDataService from './user.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import {KpSvelteComponentWrapperComponent} from 'core/kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';

/*@ngInject*/
export default function userRoutes($stateProvider: StateProvider) {
    let userList: { default: any; };
    let userAccount: { default: any; };

    $stateProvider
        .state('users', {
            url: '/users?userType',
            params: {userType: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                /*@ngInject*/
                component: () => userList.default,
                props: async (userDataService: UserDataService, finishedResponseInteractionService: FinishedResponseInteractionService) => {
                    try {
                        const usersView = await userDataService.getUsersView();
                        return {view: usersView};
                    } catch (exceptionResponse) {
                        await finishedResponseInteractionService.showFailedInModalWindow(exceptionResponse);
                        throw exceptionResponse;
                    }
                }
            },
            lazyLoad: async () => {
                userList = await import(/* webpackChunkName: "userList" */ './kp-user-list-page/KpUserListPage.svelte');
                return null;
            }
        });

    $stateProvider
        .state({
            name: 'user',
            url: '/users/:userId?activeTab',
            params: {activeTab: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                /*@ngInject*/
                component: () => userAccount.default,
                props: async (
                    $transition$: Transition,
                    kpUserAccountService: KpUserAccountPageService
                ) => {
                    const userId = $transition$.params().userId;
                    const pageData = await kpUserAccountService.loadUserAccountPageData(userId);

                    return {pageData};
                }
            },
            lazyLoad: async () => {
                userAccount = await import(/* webpackChunkName: "userAccount" */ './kp-user-account-page/KpUserAccountPage.svelte');
                return null;
            }
        });
}
